import React from 'react';

const ClientLogos = () => {
  const clients = [
    { name: 'TechCorp', logo: '🏢' },
    { name: 'FitLife', logo: '💪' },
    { name: 'Urban Fashion', logo: '👗' },
    { name: 'FinTech', logo: '💳' },
    { name: 'StartupXYZ', logo: '🚀' },
    { name: 'Digital Agency', logo: '🎨' },
    // Duplicate for seamless loop
    { name: 'TechCorp', logo: '🏢' },
    { name: 'FitLife', logo: '💪' },
    { name: 'Urban Fashion', logo: '👗' },
    { name: 'FinTech', logo: '💳' },
    { name: 'StartupXYZ', logo: '🚀' },
    { name: 'Digital Agency', logo: '🎨' }
  ];

  return (
    <section className="client-logos-section fade-in">
      <div className="section-header">
        <h2 className="section-title">Trusted by Industry Leaders</h2>
        <p className="section-subtitle">Join 250+ businesses transforming their digital presence</p>
      </div>
      
      <div className="logos-grid">
        {clients.map((client, index) => (
          <div key={index} className="logo-item">
            <div className="logo-badge">{client.logo}</div>
            <p>{client.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ClientLogos;
